import React, { Fragment, useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { loadStripe } from '@stripe/stripe-js';
import { css, StyleSheet } from 'aphrodite';

function Payment(props) {
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    setStripePromise(loadStripe(props.pubKey))
    setClientSecret(props.clientSecret)
  }, []);

  return (
    <div className={css(Styles.container)}>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm {...props}/>
        </Elements>
      )}
    </div>
  );
}

const Styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    // marginTop: 100
  },
  title: {
    fontSize: 26,
    fontWeight: 600,
    margin: 0
  }
})

export default Payment;



// WEBPACK FOOTER //
// ./src/components/advertiser/stripe/Payment.js